import { FormikProps } from 'formik';

/**
 * A curried function that initially accepts a set of FormikProps for a
 * form. Returns a new function that takes a field key and returns a set
 * of props for an input.
 *
 * @param props FormikProps for a given form
 */
export function makeInputPropsMaker<F>(props: FormikProps<F>) {
  return (field: keyof F & string) => {
    const error = props.touched[field] ? props.errors[field] : undefined;

    return {
      name: field,
      onChange: props.handleChange,
      // only mark the field touched if the value has been changed from the initial
      onBlur: () =>
        props.initialValues[field] !== props.values[field]
          ? props.setFieldTouched(field, true)
          : undefined,
      value: props.values[field],
      error,
    };
  };
}
